export default "__VITE_ASSET__Dbel7mM6__"